import React, { useState, useEffect } from 'react';
import { COOKIE_CONSENT_EVENT, COOKIE_CONSENT_KEY } from '../utils/googleAnalytics';

const saveConsent = (value) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, value);
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: value }));
};

const CookieConsent = () => {
  // First render always includes the bar so it matches prerender and does not
  // pop in. index.html hides it before paint when consent is already stored.
  const [show, setShow] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (consent) {
      setShow(false);
    }
  }, []);

  useEffect(() => {
    if (!show) {
      document.documentElement.style.removeProperty('--fx-cookie-offset');
      return undefined;
    }
    const bar = document.querySelector('[aria-label="Cookie consent"]');
    const height = bar ? bar.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--fx-cookie-offset', `${height}px`);
    return () => document.documentElement.style.removeProperty('--fx-cookie-offset');
  }, [show]);

  const handleAccept = () => {
    saveConsent('accepted');
    document.documentElement.classList.add('fx-cookie-dismissed');
    setShow(false);
  };

  const handleDecline = () => {
    saveConsent('declined');
    document.documentElement.classList.add('fx-cookie-dismissed');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white shadow-lg z-50"
      role="region"
      aria-label="Cookie consent"
    >
      <div className="max-w-7xl mx-auto px-3 py-2 flex flex-row items-center gap-2">
        <p className="flex-1 min-w-0 text-base md:text-sm leading-snug">
          <span className="sm:hidden">We use cookies to run Fixome.<br /></span>
          <span className="hidden sm:inline">By clicking &quot;Accept All Cookies&quot;, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts. </span>
          <a href="/privacy" className="underline hover:text-primary-400">
            Read our Privacy Policy
          </a>
        </p>
        <div className="flex gap-1.5 sm:gap-2 flex-shrink-0">
          <button
            type="button"
            onClick={handleDecline}
            className="px-3 py-1.5 text-base md:text-sm border border-gray-500 rounded-md hover:bg-gray-800 transition min-h-12 md:min-h-0 min-w-12 md:min-w-0"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="px-3 py-1.5 text-base md:text-sm bg-primary-500 rounded-md hover:bg-primary-600 transition min-h-12 md:min-h-0 min-w-12 md:min-w-0"
          >
            <span className="sm:hidden">Accept</span>
            <span className="hidden sm:inline">Accept All Cookies</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
